// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"584":"645e82d7","787":"fb1aeaef","890":"b9dad86e"}[chunkId] + ".chunk.js";
};